/* ── THE NAV — DISSOLVES, AND GETS OUT OF THE WAY ────────────────
   Three faults, all of which read as "a chunky block floating over
   the store":
     1. .ann is position:relative and scrolls away, but nav is fixed
        at top:32px. Past the announcement bar that leaves a 32px
        strip of raw photograph ABOVE the nav — so it stops being
        the top of the page and becomes a band laid across the
        image. nav.solid now goes to top:0.
     2. The ground was a short, near-opaque slab with a hard bottom
        edge. It is now a feather that reaches 86px BELOW the bar —
        longer than the bar is tall — so there is no edge to read.
     3. Over the porcelain sections a black scrim smears grey across
        white. The ground now takes the tone of whatever is under
        it: porcelain over porcelain, void over void.
   And it now leaves on scroll-down and returns on scroll-up, so
   nothing sits over the imagery while you are moving through it.
   Injected as a <style>, not linked — a derived stylesheet URL was
   one silent failure mode too many. ── */
(function(){
  var CSS = [
  'nav{background:none!important;border-bottom-color:transparent!important;will-change:transform;',
  '  transition:transform .46s cubic-bezier(.22,.68,.24,1),top .38s cubic-bezier(.22,.68,.24,1),',
  '             padding .5s var(--e),color .45s var(--e)!important}',
  /* z-index:-1 is load-bearing: an absolutely-positioned pseudo paints ABOVE
     the nav's non-positioned children, so without it the ground covers the
     wordmark. nav is z-index:500 and its own stacking context, so -1 sits
     behind the type and nothing else. */
  'nav::before{content:"";position:absolute;inset:0 0 -86px;z-index:-1;pointer-events:none;',
  '  opacity:0;background:linear-gradient(to bottom,',
  '    rgba(11,11,12,.74) 0%,rgba(11,11,12,.62) 26%,rgba(11,11,12,.40) 52%,',
  '    rgba(11,11,12,.18) 76%,rgba(11,11,12,0) 100%);',
  '  transition:opacity .5s var(--e),background .45s var(--e)}',
  'nav.solid{top:0!important;background:none!important;border-bottom-color:transparent!important;',
  '  backdrop-filter:none!important;-webkit-backdrop-filter:none!important}',
  'nav.solid::before{opacity:1}',
  'nav.light{color:var(--ink)!important;background:none!important;border-bottom-color:transparent!important}',
  'nav.light::before{background:linear-gradient(to bottom,',
  '    rgba(246,244,239,.95) 0%,rgba(246,244,239,.88) 26%,rgba(246,244,239,.62) 52%,',
  '    rgba(246,244,239,.26) 76%,rgba(246,244,239,0) 100%)}',
  'nav.away{transform:translateY(calc(-100% - 16px))}',
  '@media(prefers-reduced-motion:reduce){nav{transition:none!important}nav.away{transform:none}}'
  ].join('\n');
  var st = document.createElement('style');
  st.setAttribute('data-sog','nav');
  st.textContent = CSS;
  (document.head || document.documentElement).appendChild(st);
  document.documentElement.setAttribute('data-sog-nav','v3');

  function boot(){
    var nav = document.getElementById('nav');
    if(!nav) return;
    var lastY = window.scrollY || 0, ticking = false;
    var REST = 200;               /* never hide inside the first screen-top */

    /* an overlay is open — the nav must not move under it */
    function held(){
      return document.body.classList.contains('locked') ||
             !!document.querySelector('.veil.open,.pdp.open,#bagPanel.open,.sg.open');
    }

    /* what tone is the page directly under the bar? Read the first painted
       background at three points across the width. Photographs come back
       transparent and fall through to the void default, which is correct —
       the dark ground is the right one over a photograph. */
    function lightBelow(){
      if(!document.elementsFromPoint) return false;
      var y = nav.getBoundingClientRect().bottom + 12, W = window.innerWidth;
      var xs = [W*0.16, W*0.5, W*0.84], lit = 0, seen = 0;
      for(var i=0;i<xs.length;i++){
        var els = document.elementsFromPoint(xs[i], y) || [];
        for(var j=0;j<els.length;j++){
          var el = els[j];
          if(nav.contains(el)) continue;
          var m = /rgba?\(\s*([\d.]+)[,\s]+([\d.]+)[,\s]+([\d.]+)(?:[,\s/]+([\d.%]+))?/
                  .exec(getComputedStyle(el).backgroundColor);
          if(!m) continue;
          var a = m[4]===undefined ? 1 : parseFloat(m[4]);
          if(a < 0.55) continue;                       /* see through it */
          seen++;
          if((0.2126*+m[1] + 0.7152*+m[2] + 0.0722*+m[3])/255 > 0.55) lit++;
          break;
        }
      }
      return seen > 0 && lit >= Math.ceil(seen/2);
    }

    function run(){
      ticking = false;
      var y = window.scrollY || 0, past = y > 40;
      nav.classList.toggle('solid', past);
      nav.classList.toggle('light', past && lightBelow());
      if(held() || y < REST){ nav.classList.remove('away'); lastY = y; return; }
      if(y > lastY + 5){ nav.classList.add('away'); lastY = y; }
      else if(y < lastY - 5){ nav.classList.remove('away'); lastY = y; }
    }
    addEventListener('scroll', function(){
      if(ticking) return; ticking = true; requestAnimationFrame(run);
    }, {passive:true});
    addEventListener('resize', run, {passive:true});
    run();
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();


(function(){
  var A = window.SOGA || {};
  function key(u){ if(!u || u.indexOf('//') > -1 || u.indexOf('data:') === 0) return null;
    var b = u.split('/').pop(); return A[b] ? b : null; }
  function set(el, attr, k){ if(k && el.getAttribute(attr) !== A[k]) el.setAttribute(attr, A[k]); }
  function fixSrc(el){ set(el, 'src', key(el.getAttribute('src'))); }
  function fixData(el){ set(el, 'data-img', key(el.getAttribute('data-img'))); }
  function sweep(r){
    if(!r || r.nodeType !== 1) return;
    if(r.tagName === 'IMG') fixSrc(r);
    if(r.hasAttribute && r.hasAttribute('data-img')) fixData(r);
    if(!r.querySelectorAll) return;
    [].forEach.call(r.querySelectorAll('img'), fixSrc);
    [].forEach.call(r.querySelectorAll('[data-img]'), fixData);
  }
  new MutationObserver(function(ms){
    ms.forEach(function(m){
      [].forEach.call(m.addedNodes, sweep);
      if(m.type === 'attributes') sweep(m.target);
    });
  }).observe(document.documentElement,
    {childList:true, subtree:true, attributes:true, attributeFilter:['src','data-img']});
  document.addEventListener('DOMContentLoaded', function(){ sweep(document.body); });
  sweep(document.documentElement);
})();

/* ── ADD TO BAG, REPAIRED ────────────────────────────────────────
   The PDP binds its buy bar with side.querySelector('#atb'). On a
   phone the fenced mobile JS moves #atb out of .pdp-side to become
   the last row of .pdp, so that lookup returns null and the handler
   throws before it ever reaches SOG.add — the button looked alive
   and did nothing. Desktop was unaffected because the fenced JS
   never runs there.
   Bound on document in the CAPTURE phase and stopping propagation,
   so the broken per-element handler never fires. ── */
(function(){
  function side(){ return document.querySelector('.pdp-side'); }
  document.addEventListener('click', function(e){
    var t = e.target, a = t && t.closest ? t.closest('#atb') : null;
    if(a){
      e.stopPropagation(); e.preventDefault();
      var s = side(), sel = s && s.querySelector('.sizes button.sel');
      var sp = a.querySelector('span');
      a.classList.remove('warn');
      var __x=[]; var __n=document.querySelector('.pdp h1,.pdp h2,.pdp .nm');
      __x.push('want:'+(__n? __n.textContent.trim().toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/^-|-$/g,'') : ('i'+a.dataset.i)));
      if(sel) __x.push('size:'+sel.textContent.trim().toLowerCase());
      if(sp) sp.textContent = 'Join the list';
      if(window.SOGHOUSE) window.SOGHOUSE.ask('pdp', __x);
      return;
    }
    var b = t && t.closest ? t.closest('.pdp-side .sizes button') : null;
    if(b){
      e.stopPropagation();
      var s2 = side(); if(!s2) return;
      [].forEach.call(s2.querySelectorAll('.sizes button'), function(x){ x.classList.remove('sel'); });
      b.classList.add('sel');
      var bar = document.getElementById('atb');
      if(bar){ bar.classList.remove('added','warn');
        var sp2 = bar.querySelector('span');
        if(sp2 && bar.dataset.px) sp2.innerHTML = 'Add to bag &mdash; ' + bar.dataset.px;
        else if(sp2 && /Select a size|Added to bag/.test(sp2.textContent) && window.__ATBLABEL)
          sp2.innerHTML = window.__ATBLABEL; }
    }
  }, true);
  /* remember the button's original label so it can be restored */
  new MutationObserver(function(){
    var bar = document.getElementById('atb'), sp = bar && bar.querySelector('span');
    if(sp && /Add to bag/.test(sp.textContent)) window.__ATBLABEL = sp.innerHTML;
  }).observe(document.documentElement,{childList:true,subtree:true});
})();

/* ── SHOPIFY'S ADMIN BAR SITS ON THE BUY BAR ─────────────────────
   When the store is password-protected, or a theme is being
   previewed, Shopify injects <iframe id="preview-bar-iframe">
   fixed to the bottom of the viewport, roughly 70px tall. It does
   not shrink the viewport — it lays over it. On a phone the mobile
   buy bar is the last row of a position:fixed .pdp that runs to
   inset:0, which puts ADD TO BAG in exactly those bottom 54px.
   The bar covers it completely and the button looks like it was
   never built.
   Only staff ever see that bar — a customer's page is unaffected —
   but it makes the store impossible to demo, which is worse.
   So: measure it, publish the height as --sog-adminbar, and lift
   every full-screen surface clear. For customers it stays 0px and
   nothing moves by a single pixel. ── */
(function(){
  var CSS =
    '@media(max-width:640px){' +
    '.pdp{bottom:var(--sog-adminbar,0px)!important}' +
    '.bagp{bottom:var(--sog-adminbar,0px)!important}' +
    '.sg{bottom:var(--sog-adminbar,0px)!important}}';
  var st = document.createElement('style');
  st.setAttribute('data-sog','adminbar');
  st.textContent = CSS;
  (document.head || document.documentElement).appendChild(st);

  var last = -1;
  function measure(){
    var f = document.getElementById('preview-bar-iframe'), h = 0;
    if(f){
      h = Math.round(f.getBoundingClientRect().height) ||
          parseInt(getComputedStyle(f).height, 10) || 0;
      /* it is occasionally reported as 0 before it paints */
      if(!h) h = 70;
    }
    if(h === last) return;
    last = h;
    document.documentElement.style.setProperty('--sog-adminbar', h + 'px');
  }
  /* Shopify injects the bar after load, so watch for it rather than
     reading once. Cheap: only fires on body-level child changes. */
  function watch(){
    measure();
    if(!document.body) return;
    new MutationObserver(measure).observe(document.body, {childList:true});
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
  else watch();
  addEventListener('resize', measure, {passive:true});
  addEventListener('load', measure);
})();
